import { deepAssign, deepExtract } from 'helpers/deep';
import { HEADER_LAYOUT, RESULTS_LAYOUT } from '../Search.constants';
import { SearchVenue } from './SearchVenue';
import { getMapFeatureFromVenue } from '../Map/SearchMap.helpers';

export class SearchLayout {
  constructor(data = {}, config = {}) {
    const modeledData = { ...data };
    let venuesPath;
    let mapItemPath;
    if (config.layoutName === RESULTS_LAYOUT) {
      venuesPath = 'web_search_results_01.data.venue_tab_items';
      mapItemPath = 'web_search_results_01.data.map_items';
    } else if (config.layoutName === HEADER_LAYOUT) {
      venuesPath = 'nearby_venues.data';
    }

    if (venuesPath) {
      const value = deepExtract(venuesPath, modeledData, []).map(
        venue => new SearchVenue(venue, { distanceUnit: config.distanceUnit })
      );
      if (value.length) {
        deepAssign(venuesPath, modeledData, value);
      }
    }

    if (mapItemPath) {
      const mapItemById = {};
      deepExtract(mapItemPath, modeledData, []).forEach(venue => {
        mapItemById[venue.venue_id] = getMapFeatureFromVenue(venue);
      });

      deepAssign(mapItemPath, modeledData, mapItemById);
    }

    Object.assign(this, modeledData);
  }
}
